import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import Collapse from "./Collapse.css";
import swal from "sweetalert";
import useFetch from "../../Hooks/useFetch";
import Api from "./../../Hooks/Api";
const axios = require("axios").default;
const Approvalsetup = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [showCapitaion, setshowCapitaion] = useState(true);
  const [module, setModule] = useState("");
  const [moduleId, setModuleId] = useState("");
  const [ModuleApprovers, setModuleApprovers] = useState([]);
  const [NonApprovers, setNonApprovers] = useState([]);
  const [users, setUsers] = useState([]);
  const [approverModule, setApproverModule] = useState([]);
  const url = "api/approvers";

  const fetchUsers = async () => {
    try {
      Api.get("api/registration/getAllUsers")
        .then(function (response) {
          if (response.status === 200) {
            setUsers(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchModules = async () => {
    try {
      Api.get("api/approvalModules/getAll")
        .then(function (response) {
          if (response.status === 200) {
            setApproverModule(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  useEffect(() => {
    fetchUsers();
    fetchModules();
  }, []);
  const handleOpenModal = (event) => {
    event.persist();
    if (moduleId) {
      setInputs({});
      setOpen(true);
    } else {
      swal("", "Select Module to continue", "error");
    }
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    let data = {
      minApprovers: inputs.minApprovers,
      moduleId: moduleId,
    };
    useSave("api/approvalModules/submitApprovers", data);
  };
  const fetchApproversByModuleID = (moduleID) => {
    Api.get(url + "/getByModuleId?id=" + moduleID)
      .then(function (response) {
        setModuleApprovers(response.data);
        let NonApprovers = [];

        users.map((k, i) => {
          let IsAvailable = response.data.filter(
            (option) => option.userId === k.id
          );
          if (IsAvailable.length === 0) {
            NonApprovers.push(k);
          }
        });

        setNonApprovers(NonApprovers);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  };
  const fetchModuleMinimum = (moduleID) => {
    approverModule.map((k, i) => {
      if (moduleID === k.moduleId) {
        setInputs((inputs) => ({
          ...inputs,
          minApprovers: k.minApprovers,
        }));
      }
    });
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const handleSelectChange = (UserGroup, actionMeta) => {
    setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
  };
  const HandleCheckMandatoryBoxChange = (k, e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let data = {
      moduleId: moduleId,
      userId: k,
      mandatory: true,
      deleted: value ? false : true,
    };
    useSave(url + "/create", data);
    fetchApproversByModuleID(moduleId);
  };
  const HandleCheckBoxChange = (k, e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let data = {
      moduleId: moduleId,
      userId: k,
      mandatory: false,
      deleted: value ? false : true,
    };
    useSave(url + "/create", data);
    fetchApproversByModuleID(moduleId);
  };

  const ToggleDive1 = () => {
    setshowCapitaion(!showCapitaion);
  };

  const handleSelectModule = (k, e) => {
    const id = k.moduleId;
    const name = k.module;
    setModule(name);
    setModuleId(id);
    fetchApproversByModuleID(id);
    fetchModuleMinimum(id);
  };
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Approvers</li>
      </ol>
      <h1 class="page-header mb-3">Approvers</h1>
      <div style={{ backgroundColor: "white" }}>
        <br />
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-4">
                <div class="card">
                  <div
                    class="card-header"
                    style={{ background: "#55A26C", color: "white" }}
                  >
                    Approval Levels
                  </div>
                  <div class="card-body">
                    <button
                      type="button"
                      class="collapsible"
                      onClick={ToggleDive1}
                    >
                      Modules
                    </button>
                    {showCapitaion ? (
                      <div class="collapsiblecontent">
                        <ul class="list-group list-group-flush">
                          {approverModule.map((k, i) => {
                            return (
                              <li
                                class="list-group-item"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => handleSelectModule(k, e)}
                              >
                                {k.module}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="row">
                  <div class="col-sm-12 d-flex flex-row float-right">
                    <h3>{module}</h3>
                  </div>
                </div>
                <div className="row">
                  <div class="col-sm-12 d-flex flex-row float-right">
                    &nbsp; &nbsp; &nbsp;
                    <button
                      onClick={handleOpenModal}
                      className="btn btn-success p-2"
                      style={{ marginRight: 5, marginTop: 5 }}
                    >
                      New
                    </button>
                    <button
                      onClick={handleOpenModal}
                      className="btn btn-info p-2"
                      style={{ marginRight: 5, marginTop: 5 }}
                    >
                      Edit{" "}
                    </button>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-12">
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">Login name</th>
                          <th scope="col">Name</th>
                          <th scope="col">Mandatory</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ModuleApprovers.map((k, i) => {
                          return (
                            <tr>
                              <td>{k.user ? k.user.username : ""}</td>
                              <td>{k.user ? k.user.name : ""}</td>
                              <td>{k.mandatory ? "Yes" : "No"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal visible={open} width="75%" height="70%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <div class="card">
            <div class="card-header">
              Approva Hierachy -{module}
              <a
                className="close"
                style={{ color: "Red", cursor: "pointer" }}
                onClick={() => handleCloseModal()}
              >
                &times;{" "}
              </a>
            </div>
            <div class="card-body">
              <div className="container-fluid">
                <div className="col-sm-12">
                  <div className="ibox-content">
                    <br />

                    {view ? (
                      <div>
                        <h3>Roles</h3>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td className="font-weight-bold">Name:</td>
                              <td>{inputs.name}</td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row">
                            <div className="col-sm-6">
                              <div class="card">
                                <div class="card-header">Mandatory</div>
                                <div class="card-body">
                                  <ul class="list-group list-group-flush">
                                    {ModuleApprovers.map((x, i) => {
                                      return x.mandatory ? (
                                        <li class="list-group-item">
                                          <input
                                            className="checkbox"
                                            id={i}
                                            type="checkbox"
                                            name="Create"
                                            defaultChecked={true}
                                            onChange={(e) =>
                                              HandleCheckMandatoryBoxChange(
                                                x.userId,
                                                e
                                              )
                                            }
                                          />
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {x.user.name}
                                          </span>
                                        </li>
                                      ) : null;
                                    })}
                                    {NonApprovers.map((x, i) => {
                                      return (
                                        <li class="list-group-item">
                                          <input
                                            className="checkbox"
                                            id={i}
                                            type="checkbox"
                                            name="Create"
                                            defaultChecked={false}
                                            onChange={(e) =>
                                              HandleCheckMandatoryBoxChange(
                                                x.id,
                                                e
                                              )
                                            }
                                          />
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {x.name}
                                          </span>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div class="card">
                                <div class="card-header">Optional</div>
                                <div class="card-body">
                                  <ul class="list-group list-group-flush">
                                    {ModuleApprovers.map((x, i) => {
                                      return x.mandatory ? null : (
                                        <li class="list-group-item">
                                          <input
                                            className="checkbox"
                                            id={i}
                                            type="checkbox"
                                            name="Create"
                                            defaultChecked={true}
                                            onChange={(e) =>
                                              HandleCheckBoxChange(x.userId, e)
                                            }
                                          />
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {x.user.name}
                                          </span>
                                        </li>
                                      );
                                    })}
                                    {NonApprovers.map((x, i) => {
                                      return (
                                        <li class="list-group-item">
                                          <input
                                            className="checkbox"
                                            id={i}
                                            type="checkbox"
                                            name="Create"
                                            defaultChecked={false}
                                            onChange={(e) =>
                                              HandleCheckBoxChange(x.id, e)
                                            }
                                          />
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            {x.name}
                                          </span>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                  <br />
                                  <div class="form-group row">
                                    <label
                                      for="staticEmail"
                                      class="col-sm-8 col-form-label"
                                      style={{ float: "right" }}
                                    >
                                      Minimum Approval Required
                                    </label>
                                    <div class="col-sm-4">
                                      <form onSubmit={HandleSubmit}>
                                        <input
                                          type="number"
                                          name="minApprovers"
                                          required
                                          className="form-control"
                                          value={inputs.minApprovers}
                                          onChange={handleInputChange}
                                        />
                                        <br />
                                        <button
                                          className="btn btn-primary float-right"
                                          type="submit"
                                        >
                                          Submit
                                        </button>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default Approvalsetup;
